module.exports = __webpack_public_path__ + "img/Logo-Era-Tua-Home.4163659.svg";